import { create } from 'zustand';
import type { ActiveTimer, Session } from '@timato/shared';

export type Completion = { session: Session; timer: ActiveTimer; kind: 'focus' | 'track' | 'break' };

/** The most recent completion, for the end-of-session card (8f). Cleared when dismissed or when a new run starts. */
export const useCompletionStore = create<{ completion: Completion | null; set: (c: Completion | null) => void }>((set) => ({
  completion: null, set: (completion) => set({ completion }),
}));
